function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoLocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 400,
  height: 360
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M103.164 353.793C94.691 351.961-7.098 335.461.394 213.762 7.888 92.059 17.294 55.46 56.868 42.07 96.441 28.68 192.641-34.68 268.13 25.566c19.598 15.637 39.562 30.77 58.637 47.137 26.21 22.492 53.16 48.469 66.043 82.504a111.7 111.7 0 0 1 6.652 50.414c-1.973 20.082-4.75 39.617-9.809 59.188l-5.16 19.984c-1.035 4-2.074 8.023-3.699 11.793-10.473 24.277-23.676 40.21-45.8 53.14-19.2 11.215-42.993 10.922-64.2 9.688-84.336-4.91-127.344 3.09-167.629-5.621m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#f9f9f9",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.582 312.371c-4.988-.851-6.82-1.875-4.422-3.101 16.692-8.54 91.547-8.657 127.856-8.829 45.672-.218 93.195-.68 134.316 1.176 17.207.774 56.207 1.371 62.875 4.2 17.488 7.425-106.969 10.117-127.11 10.32-33.577.336-165.019 1.093-193.515-3.766m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#e3e3e3",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.406 324.902c-1.87-.832-2.558-1.828-1.656-3.027 6.262-8.332 34.352-8.45 47.977-8.617 17.136-.211 34.968-.66 50.398 1.148 6.457.754 21.094 1.336 23.594 4.098 6.562 7.246-40.137 9.875-47.696 10.074-12.597.328-61.921 1.067-72.617-3.676M326.36 76.246H65.901a6.3 6.3 0 0 0-6.297 6.297v224.695h270.848V80.34a4.095 4.095 0 0 0-4.094-4.094m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#e3e3e3",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M331.184 76.246H70.723a6.297 6.297 0 0 0-6.293 6.297v224.695h270.847V80.34a4.095 4.095 0 0 0-4.093-4.094m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.328 307.992h74.875c.402 0 1.055-.344 1.055-.812V83.098c0-2.364.316-4.926-1.836-6.578-1.66-1.282-3.883-1.024-5.856-1.024H73.356c-2.29 0-4.477-.133-6.54 1.176-3.101 1.973-3.367 5.004-3.367 8.207V307.3c0 .512.461.691.906.691h73.528c1.137 0 1.453-1.504.144-1.504H64.504l.906.692V85.227c0-3.223-.113-7.016 3.914-8.067 1.387-.36 3.074-.16 4.485-.16H328.28c2.438 0 5.41-.406 5.95 2.957.218 1.363.062 2.84.062 4.215V307.3l1.059-.813h-74.88c-1.136 0-1.452 1.504-.144 1.504m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.277 94.441H64.43v-14.5a3.7 3.7 0 0 1 3.695-3.695h263.457a3.7 3.7 0 0 1 3.695 3.695Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#efefef",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.68 93.992H68.934c-1.172 0-2.493-.168-3.657 0a3 3 0 0 1-.445 0l.563.192c0-4.793-.332-9.707 0-14.489.214-3.058 2.156-3 4.246-3h257.492c1.25 0 2.523-.066 3.773 0 1.996.11 3.281 1.563 3.406 3.54.16 2.515 0 5.09 0 7.609v6.855c0 .426 1.93.117 1.93-.515v-7.25c0-2.473.223-5.059-.02-7.524-.304-3.082-3.046-3.613-5.53-3.613H71.651c-1.023 0-2.054-.04-3.074 0-2.61.098-4.96 1.644-5.113 4.41-.133 2.465 0 4.973 0 7.441V94.7c0 .207.46.196.562.196h237.43c10.969 0 22.008.355 32.973 0 .148-.008.297 0 .445 0 .605 0 2.09-.903.805-.903m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.488 85.344c0-2.328-1.894-4.215-4.238-4.215-2.34 0-4.238 1.887-4.238 4.215 0 2.332 1.898 4.219 4.238 4.219a4.225 4.225 0 0 0 4.238-4.22m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.457 85.086c-.34-6.281-10.383-5.547-10.41.453-.027 6.356 10.086 5.606 10.406-.324.04-.742-1.894-.348-1.926.262-.101 1.878-1.39 3.98-3.59 3.488A3.91 3.91 0 0 1 76 85.152c-.004-2.047 1.7-4.074 3.895-3.312 1.656.574 2.535 2.07 2.628 3.765.032.57 1.97.188 1.934-.52m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.207 85.344c0-2.328-1.898-4.215-4.238-4.215-2.344 0-4.242 1.887-4.242 4.215 0 2.332 1.898 4.219 4.242 4.219 2.34 0 4.238-1.887 4.238-4.22m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.172 85.086c-.34-6.313-10.402-5.625-10.41.445-.008 6.387 10.086 5.7 10.414-.3.043-.82-1.899-.45-1.938.23-.101 1.906-1.418 3.902-3.593 3.46-1.739-.35-2.926-2.046-2.926-3.76.004-2.075 1.722-3.97 3.902-3.286 1.66.523 2.531 2.07 2.621 3.73.035.657 1.973.254 1.93-.52m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.926 85.344c0-2.328-1.899-4.215-4.242-4.215-2.34 0-4.239 1.887-4.239 4.215 0 2.332 1.899 4.219 4.239 4.219 2.343 0 4.242-1.887 4.242-4.22m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.89 85.086c-.335-6.215-10.386-5.29-10.41.52-.027 6.285 10.098 5.21 10.41-.52.012-.23-1.902-.023-1.933.52-.121 2.238-1.875 4.394-4.305 3.16a4.14 4.14 0 0 1-2.242-3.68c.016-2.14 1.832-4.273 4.113-3.262a4.23 4.23 0 0 1 2.434 3.781c.016.293 1.961-.015 1.934-.52m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.984 285.68h55.723c1.094 0 1.488-1.395.176-1.395H168.16c-1.097 0-1.488 1.395-.176 1.395m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.469 279.332h148.797c6.875 0 13.832.32 20.703 0 .097-.004.199 0 .297 0 .382 0 2.171-.734 1.265-.734H136.734c-6.875 0-13.832-.32-20.703 0-.097.004-.199 0-.297 0-.382 0-2.171.734-1.265.734m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#efefef",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.46 112.504h214.786a3.54 3.54 0 0 1 3.54 3.539v12.21a3.54 3.54 0 0 1-3.54 3.544H92.461a3.54 3.54 0 0 1-3.54-3.543v-12.211a3.54 3.54 0 0 1 3.54-3.54M227.605 166.273h80.043a3.14 3.14 0 0 1 3.137 3.141v90.184a3.14 3.14 0 0 1-3.137 3.14h-80.043a3.14 3.14 0 0 1-3.14-3.14v-90.184a3.14 3.14 0 0 1 3.14-3.14m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#f4f4f4",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.574 197.758H234.98c-.699 0-2.058 1.054-.761 1.054h64.594c.699 0 2.058-1.054.761-1.054M269.727 180.527h-34.75c-.73 0-2.051 1.098-.75 1.098h34.75c.726 0 2.05-1.098.75-1.098M299.824 215.418H235.23c-.39 0-2.175.754-1.261.754h64.59c.394 0 2.18-.754 1.265-.754M299.813 232.918h-29.067c-.7 0-2.058 1.055-.758 1.055h29.063c.699 0 2.058-1.055.762-1.055M289.215 250.406h-54c-.73 0-2.05 1.098-.75 1.098h54c.726 0 2.047-1.098.75-1.098m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.648 221.715h48.196v41.023h-48.196Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#efefef",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.758 250.473h-27.074c-.403 0-2.184.765-1.262.765H200.5c.398 0 2.18-.765 1.258-.765M201.156 241.586h-26.75c-.84 0-2.008 1.266-.707 1.266h26.75c.84 0 2.008-1.266.707-1.266M201.52 232.516h-27.176c-.645 0-2.078.964-.79.964h27.18c.645 0 2.078-.964.79-.964Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.785 166.273h41.922a3.137 3.137 0 0 1 3.137 3.141v34.742a3.137 3.137 0 0 1-3.137 3.14h-41.922a3.137 3.137 0 0 1-3.137-3.14v-34.742a3.137 3.137 0 0 1 3.137-3.14m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#f4f4f4",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.89 186.082h-26.75c-1.093 0-1.488 1.39-.175 1.39h26.75c1.094 0 1.488-1.39.176-1.39m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.793 146.754h189.848c2.554 0 5.203.2 7.75 0 .113-.008.23 0 .343 0 1.094 0 1.493-1.387.18-1.387H109.066c-2.554 0-5.203-.199-7.75 0-.113.008-.23 0-.343 0-1.094 0-1.493 1.387-.18 1.387m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#efefef",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.059 166.273h55.355a3.137 3.137 0 0 1 3.137 3.141v90.184a3.137 3.137 0 0 1-3.137 3.14H92.06a3.137 3.137 0 0 1-3.137-3.14v-90.184a3.137 3.137 0 0 1 3.137-3.14m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#f4f4f4",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.45 248.543h-37.481c-.399 0-2.18.766-1.258.766h37.48c.399 0 2.18-.766 1.258-.766M139.215 230.586H101.59c-.645 0-2.078.969-.785.969h37.62c.645 0 2.083-.97.79-.97M134.574 216.793h-27.906c-1.656 0-3.418.234-4.707-1.074-1.32-1.34-1.086-3.211-1.086-4.918v-16.38c0-3.812-.246-7.714 0-11.523.191-2.925 2.086-3.246 4.328-3.246h24.41c1.223 0 2.477-.082 3.696 0 2.816.188 3.578 2.5 3.578 4.844v26.121c0 2.043.488 5.977-2.52 6.18-.523.035-2.097.875-.832.789 2.79-.188 5.195-1.774 5.281-4.758.055-1.805 0-3.621 0-5.43v-19.03c0-3.735.914-9.368-4.445-9.516-4.879-.137-9.785 0-14.668 0-5.004 0-10.02-.094-15.027 0-2.528.046-5.309 1.214-5.696 4.027-.183 1.336-.035 2.77-.035 4.11v25.554c0 2.406.926 4.613 3.63 5.004 1.316.191 2.73.047 4.054.047h26.7c.417 0 2.187-.801 1.245-.801m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M200 150.992c-32.066 0-58.062 25.996-58.062 58.063v35.41h16.75v-34.98c0-22.817 18.496-41.317 41.312-41.317s41.313 18.5 41.313 41.316v19.438h16.75v-19.867c0-32.067-25.997-58.063-58.063-58.063m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#efefef",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.105 150.992H200c-26.254 0-52.969 25.996-52.969 58.063l-.398 35.41h12.054v-34.98c0-22.817 18.497-41.317 41.313-41.317h-3.04c34.56-2.129 49.45 18.5 49.45 41.316v19.438h11.653v-22.977c0-30.351-24.606-54.953-54.958-54.953m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.027 217.11c0-4.434.164-8.907-.21-13.325a58 58 0 0 0-5.958-21.066 58.83 58.83 0 0 0-30.574-28.016c-26.762-10.672-58.582.207-73.242 24.977a57.9 57.9 0 0 0-7.715 23.148c-.562 5.145-.355 10.363-.355 15.531 0 .38 1.93.086 1.93-.52 0-3.94-.122-7.905.066-11.843a57.63 57.63 0 0 1 33.426-49.586c13.242-6.05 28.64-6.547 42.328-1.664a57.87 57.87 0 0 1 37.996 47.914c.566 4.957.379 9.985.379 14.965 0 .379 1.93.086 1.93-.516m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.652 217.398c0-7.75-.148-15.296 2.645-22.687a41.02 41.02 0 0 1 20.266-22.277c19.8-9.602 44.195-.23 53.667 19.308a41.3 41.3 0 0 1 4.094 16.602c.102 3.117.024 6.246.024 9.363 0 .344 1.933.063 1.933-.516 0-2.843.04-5.687-.004-8.527a41.4 41.4 0 0 0-3.562-16.246 41.89 41.89 0 0 0-22.09-21.492c-19.785-8.211-43.746.246-53.941 19.086a41.5 41.5 0 0 0-4.907 17.5c-.183 3.457-.058 6.945-.058 10.406 0 .344 1.93.062 1.93-.52Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.508 322.352h-41.016c-26.965 0-48.828-21.864-48.828-48.832v-41.852c0-5.356 4.344-9.695 9.695-9.695h119.282c5.351 0 9.695 4.34 9.695 9.695v41.852c0 26.968-21.863 48.832-48.828 48.832m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#96e296",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.133 319.258h-44.164c-24.41 0-44.2-19.79-44.2-44.2v-44.757c0-4.598 3.727-8.328 8.325-8.328h115.914a8.33 8.33 0 0 1 8.328 8.328v44.758c0 24.41-19.79 44.199-44.203 44.199m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#b9f7ba",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.098 301.035c-8.153 11.973-21.141 19.832-35.703 20.711-4.883.293-9.829.082-14.711.082H187.14c-5.696 0-11.41.219-17.032-.879-21.55-4.222-37.699-23.441-38.449-45.332-.414-12.12-.027-24.308-.027-36.433 0-4.954-1.196-11.938 3.363-15.293 2.508-1.848 5.961-1.395 8.914-1.395h113.227c.886 0 1.777-.016 2.664 0a8.58 8.58 0 0 1 8.176 6.024c.52 1.687.39 3.507.39 5.257v31.286c0 5.785.297 11.683-.726 17.398a49.5 49.5 0 0 1-7.543 18.574c-.47.707 1.457.516 1.793.012 5.695-8.606 8.41-18.297 8.41-28.578v-39.88c0-2.316-.04-4.487-1.281-6.577-1.786-2.992-4.97-4.508-8.38-4.559-8.394-.129-16.8 0-25.199 0H148c-2.629 0-5.262-.039-7.89 0-3.231.047-6.364 1.309-8.403 3.879-1.687 2.129-2.004 4.594-2.004 7.195v39.864c0 8.082 1.29 15.886 4.879 23.207a48.95 48.95 0 0 0 21.856 22.093c7.394 3.715 15.37 5.18 23.59 5.18h39.574c10.527 0 20.804-2.734 29.507-8.793a50.3 50.3 0 0 0 12.782-13.031c.472-.7-1.45-.512-1.793-.012m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.14 296.7h-24.28l5.792-27.72a11.42 11.42 0 0 1-5.793-9.98c0-6.285 5-11.379 11.16-11.379 6.165 0 11.16 5.094 11.16 11.379 0 4.3-2.34 8.04-3.835 9.977Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#efefef",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.438 293.469H194.69a1.407 1.407 0 0 1-1.383-1.676l4.079-21.496a1.43 1.43 0 0 0-.547-1.395 10.24 10.24 0 0 1-3.852-8.168c0-5.457 3.942-9.879 8.805-9.879 4.86 0 8.8 4.422 8.8 9.88 0 3.413-1.542 6.425-2.71 8.199a1.38 1.38 0 0 0-.207 1.035l4.144 21.828c.078.41-.03.836-.3 1.16a1.4 1.4 0 0 1-1.083.512m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.398 268.426c-6.562-3.903-7.628-13.809-1.082-18.352 6.344-4.402 14.809.242 15.786 7.555.539 4.035-1.22 7.476-3.32 10.75-.548.851-.313 1.277-.11 2.254l2.433 11.64 2.391 11.43c.176.848.613 1.918-.516 2.297-1.05.352-2.82 0-3.917 0h-13.18c-1.305 0-3.496.61-3.617-1.418-.04-.68.332-1.578.468-2.238l4.899-23.442c.195-.937-1.778-.699-1.957.153l-4.992 23.882c-.204.989-.649 2.172-.188 3.141.73 1.531 2.52 1.32 3.93 1.32h14.46c2.52 0 7.372.696 6.723-3.32-.64-4-1.664-7.973-2.492-11.933-.883-4.227-1.863-8.446-2.652-12.692a2.4 2.4 0 0 1-.113-.543c.035-.3.05.012.043.027.222-.574.851-1.207 1.171-1.73a19.4 19.4 0 0 0 1.418-2.777c1.43-3.489 1.645-7.38-.035-10.82-3.332-6.829-12.37-8.715-18.32-4.102-6.738 5.23-6.016 15.691 1.281 20.023.719.43 2.418-.554 1.488-1.105m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#637082",
    fillOpacity: 1
  }
}));
export default SvgIcoLocked;